import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#111] text-white/50">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          {/* Brand */}
          <div>
            <p className="text-white font-semibold text-[15px] mb-3">3D-Druck Potsdam</p>
            <p className="text-[13px] leading-relaxed">
              CAD-Konstruktion, technisches Zeichnen,<br />
              Ingenieurberatung und 3D-Druck, alles aus einer Hand.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-[11px] uppercase tracking-widest text-white/30 mb-4">Navigation</p>
            <ul className="space-y-2 text-[13px]">
              <li><Link to="/" className="hover:text-white transition-colors">Startseite</Link></li>
              <li><Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutzerklärung</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[11px] uppercase tracking-widest text-white/30 mb-4">Kontakt</p>
            <address className="not-italic space-y-3 text-[13px]">
              <div className="flex items-start gap-2.5">
                <MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-white/30" />
                <span>Brauerstraße 1, 14467 Potsdam</span>
              </div>
              <div className="flex items-center gap-2.5">
                <Mail className="w-3.5 h-3.5 shrink-0 text-white/30" />
                <a href="mailto:konstantin.florian.kalla@3d-druck-potsdam.de" className="hover:text-white transition-colors break-all">
                  konstantin.florian.kalla@3d-druck-potsdam.de
                </a>
              </div>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-[12px]">
          <p>© {year} 3D-Druck Potsdam · Konstantin Florian Kalla</p>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
